<template>
  <form ref="alipayForm" :action="alipayUrl" class="alipay-form" method="get">
    <input v-model="alipayParam.app_id" name="app_id">
    <input v-model="alipayParam.method" name="method">
    <input v-model="alipayParam.format" name="format">
    <input v-model="alipayParam.return_url" name="return_url">
    <input v-model="alipayParam.charset" name="charset">
    <input v-model="alipayParam.sign_type" name="sign_type">
    <input v-model="alipayParam.sign" name="sign">
    <input v-model="alipayParam.timestamp" name="timestamp">
    <input v-model="alipayParam.version" name="version">
    <input v-model="alipayParam.notify_url" name="notify_url">
    <input v-model="alipayParam.app_auth_token" name="app_auth_token">
    <input v-model="alipayParam.biz_content" name="biz_content">
  </form>
</template>

<script>
export default {
  name: 'AlipayForm',
  props: {
  },
  data() {
    return {
      alipayUrl: 'https://openapi.alipay.com/gateway.do',
      alipayParam: {
        app_id: '',
        method: 'alipay.trade.page.pay',
        format: 'JSON',
        return_url: '',
        charset: 'utf-8',
        sign_type: 'RSA2',
        sign: '',
        timestamp: '',
        version: '1.0',
        notify_url: '',
        app_auth_token: '',
        biz_content: ''
      }
    }
  },
  methods: {
    initForm(payUrl, payParams) {
      if(payUrl) {
        this.alipayUrl = payUrl
      }
      if(payParams) {
        this.alipayParam = Object.assign(this.alipayParam, payParams)
      }
    },
    submitPay(payUrl, payParams) {
      this.initForm(payUrl, payParams)
      console.log(this.$refs['alipayForm'])
      this.$nextTick(() => {
        this.$refs['alipayForm'].submit()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-form {
  display: none;
}
</style>
